// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./spinner.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.em-button {
    width: 35px;
    height: 35px;
    user-select: none;
    cursor: pointer;
}

.em-button rect {
    fill: white;
    stroke: #ccc;
}

.em-button rect:hover {
    fill: lightgrey;
}

.em-button text {
    text-anchor: middle;
    font-size: 20px;
    fill: #333333;
}

/* zoom  */
/* .em-zoom-buttons {
    transform: translate(94%, 10%);
} */

/* insets */
/* .em-insets-button {
    transform: translate(94%, 2%);
} */

.em-logo-group {
    pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/css/ui.css"],"names":[],"mappings":"AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,aAAa;AACjB;;AAEA,UAAU;AACV;;GAEG;;AAEH,WAAW;AACX;;GAEG;;AAEH;IACI,oBAAoB;AACxB","sourcesContent":["@import 'spinner.css';\r\n.em-button {\r\n    width: 35px;\r\n    height: 35px;\r\n    user-select: none;\r\n    cursor: pointer;\r\n}\r\n\r\n.em-button rect {\r\n    fill: white;\r\n    stroke: #ccc;\r\n}\r\n\r\n.em-button rect:hover {\r\n    fill: lightgrey;\r\n}\r\n\r\n.em-button text {\r\n    text-anchor: middle;\r\n    font-size: 20px;\r\n    fill: #333333;\r\n}\r\n\r\n/* zoom  */\r\n/* .em-zoom-buttons {\r\n    transform: translate(94%, 10%);\r\n} */\r\n\r\n/* insets */\r\n/* .em-insets-button {\r\n    transform: translate(94%, 2%);\r\n} */\r\n\r\n.em-logo-group {\r\n    pointer-events: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
